import {mapActions, mapGetters} from 'vuex'

export const downloadMixin = {
  computed: {
    ...mapGetters({
      'downloads': 'downloads/all'
    })
  },
  methods: {
    ...mapActions({
      'getUserDownloads': 'downloads/getUserDownloads',
      'getCreativeDownloads': 'downloads/getCreativeDownloads',
      'getDownload': 'downloads/getDownload',
      'createSignedDownloadRequest': 'downloads/createSignedDownloadRequest',
      'processDownload': 'downloads/processDownload'
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/downloadMixin.js